import 'css-chunksrc/client/scenes/taskCreation/taskCreationForm/styles.scss';export default {
  "taskCreationForm": "_taskCreationForm_1yzg1_1",
  "projectSelectionRow": "_projectSelectionRow_1yzg1_8",
  "group": "_group_1yzg1_12",
  "title": "_title_1yzg1_21",
  "dateGroup": "_dateGroup_1yzg1_26",
  "checkbox": "_checkbox_1yzg1_36",
  "checked": "_checked_1yzg1_50",
  "selectAllDayBox": "_selectAllDayBox_1yzg1_67",
  "selectAllDayDescription": "_selectAllDayDescription_1yzg1_72",
  "listSelect": "_listSelect_1yzg1_76",
  "dateTimeInput": "_dateTimeInput_1yzg1_80",
  "row": "_row_1yzg1_85",
  "textArea": "_textArea_1yzg1_101",
  "descriptionTitle": "_descriptionTitle_1yzg1_105"
};